import React, { useEffect, useRef, useState } from "react";
import { Avatar, Typography, message, Spin, Empty } from "antd";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs, updateDoc, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { AreaChart, Area, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from "recharts";
import dayjs from "dayjs";
const { Text } = Typography;
const cards = [
  { title:"Booking",emoji:"🪑",description:"Réserve ta place à distance",link:"/booking" },
  { title:"Minuteur",emoji:"⏲️",description:"Vérifie ton temps de sortie",link:"/table" },
  { title:"Loyalty",emoji:"💖",description:"Gagne des points lors de ta visite",link:"/loyalty" },
  { title:"Printing",emoji:"🖨️",description:"Imprime tes documents",link:"/print" },
  { title:"Buvette",emoji:"☕",description:"Snacks & boissons",link:"/buvette" },
  { title:"Powerbank",emoji:"🔋",description:"Emprunte une batterie",link:"/powerbank" },
  { title:"Incident",emoji:"🚨",description:"See it, Say it, Sort it",link:"/incidents" },
  { title:"Casier",emoji:"🗄️",description:"Réserve ton casier",link:"/casier" },
  { title:"WeBot",emoji:"🤖",description:"Connecte le mini bot sur ta table",link:"/webot"},
   { title:"Booth",          emoji:"🚪", description:"Réserve un booth — 2 personnes max",    link:"/booth" },
  { title:"Équipements",    emoji:"🎧", description:"Emprunte du matériel",                  link:"/equipment" },
  { title:"Bibliothèque",   emoji:"📚", description:"Consulte et emprunte des livres",       link:"/library" },
  { title:"Mon Compte",emoji:"🪪",description:"Profil & paramètres",link:"/mon-compte" },
  { title:"Payer en Ligne",emoji:"💳",description:"Solde ou abonnement",link:"/payment" },
  { title:"Parrainage",emoji:"🎁",description:"Invite & gagne des remises",link:"/refer" },
  { title:"Late Access",emoji:"🌙",description:"Etudie la nuit",link:"/latenight" },
  { title:"Vote",emoji:"🗳️",description:"Propose des idées",link:"/feedback",wide:true },
];
const RULES = [
  { id:1,  fr:"Je maintiens le silence à l'intérieur de l'espace de travail.", ar:"أتعهد بالحفاظ على الصمت داخل فضاء العمل." },
  { id:2,  fr:"Je laisse ma table propre après chaque utilisation.", ar:"أتعهد بترك طاولتي نظيفة بعد كل استخدام." },
  { id:3,  fr:"Je jette mes déchets dans les poubelles prévues et je respecte le tri.", ar:"أتعهد برمي نفاياتي في السلال المخصصة واحترام الفرز." },
  { id:4,  fr:"Je n'utilise pas de gobelets en papier à l'intérieur ni à l'extérieur de WeStudy. Pour le café et les boissons chaudes, je demande un verre WeStudy à l'accueil.", ar:"أتعهد بعدم استخدام الأكواب الورقية داخل أو خارج WeStudy. للقهوة والمشروبات الساخنة، أطلب كوب WeStudy من الاستقبال." },
  { id:5,  fr:"Je ne consomme pas d'aliments à forte odeur à l'intérieur.", ar:"أتعهد بعدم استهلاك أطعمة ذات رائحة قوية داخل الفضاء." },
  { id:6,  fr:"Je veille à mon hygiène corporelle avant chaque visite, par respect pour les autres membres.", ar:"أتعهد بالاعتناء بنظافتي الشخصية قبل كل زيارة احتراماً للأعضاء الآخرين." },
  { id:7,  fr:"J'adopte un comportement respectueux à l'extérieur de WeStudy sur toute la longueur de l'Avenue Farhat Hached.", ar:"أتعهد بالتصرف باحترام خارج WeStudy على امتداد نهج فرحات حشّاد كاملاً." },
  { id:8,  fr:"Je ne provoque aucune bagarre, altercation ou incident sur l'Avenue Farhat Hached, et je ne succombe pas aux provocations des passants.", ar:"أتعهد بعدم إثارة أي شجار أو مشادة على نهج فرحات حشّاد، ولا أنجرف لاستفزازات المارة." },
  { id:9,  fr:"Je respecte le stationnement réglementé : je ne gare pas mon véhicule en double file, sur les trottoirs, devant les accès privés ou aux endroits interdits aux abords de WeStudy.", ar:"أتعهد باحترام قواعد الوقوف : لا أقف في صفين، لا على الأرصفة، ولا أمام المداخل الخاصة، ولا في الأماكن الممنوعة بالقرب من WeStudy." },
  { id:10, fr:"Je maintiens la propreté de la rue devant WeStudy : je ne jette pas de déchets, papiers ou emballages au sol. Je ne jette pas mes mégots de cigarette devant l'établissement.", ar:"أتعهد بالحفاظ على نظافة الشارع أمام WeStudy : لا أرمي النفايات أو الأوراق على الأرض. لا أرمي أعقاب السجائر أمام المؤسسة." },
  {
  id: 11,
  fr: "Je respecte mes réservations : 3 absences ou retards significatifs entraînent automatiquement une suspension de mon droit de réservation pendant 15 jours.",
  ar: "أحترم حجوزاتي: 3 حالات غياب أو تأخير كبير تؤدي تلقائيًا إلى تعليق حقي في الحجز لمدة 15 يومًا."
},
  { id:12, fr:"Je respecte les lois tunisiennes en vigueur (Code Pénal, Art. 214, 226 bis — Code de la Route, Art. 95).", ar:"أتعهد باحترام القوانين التونسية المعمول بها (المجلة الجزائية، الفصول 214، 226 مكرر — مجلة الطرقات، الفصل 95)." },
  { id:13, fr:"Je comprends et j'accepte que tout manquement à ce règlement entraîne mon exclusion définitive de WeStudy, sans préavis ni remboursement, quelle que soit la durée de mon abonnement.", ar:"أقرّ وأقبل بأن أي مخالفة لهذا النظام تستوجب طردي النهائي من WeStudy دون إشعار مسبق ودون استرجاع أي مبلغ، بصرف النظر عن مدة اشتراكي." },
];
const BAR_COLORS = ["#2563eb","#378ADD","#85B7EB","#1d4ed8","#3b82f6","#60a5fa"];

export default function HomePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [picUrl,setPicUrl] = useState(null);
  const [quote,setQuote] = useState("Le succès est la somme de petits efforts répétés jour après jour.");
  const [author,setAuthor] = useState("");
  const [fullName,setFullName] = useState("Utilisateur");
  const [loyaltyPoints,setLoyaltyPoints] = useState(null);
  const [loyaltyStamps,setLoyaltyStamps] = useState(null);
  const [showReglement,setShowReglement] = useState(false);
  const [showReservationBlockModal, setShowReservationBlockModal] = useState(false);
  const [checkedRules,setCheckedRules] = useState({});
  const [reglementSigned,setReglementSigned] = useState(false);
  const [signingLoading,setSigningLoading] = useState(false);
  const [reglementLang,setReglementLang] = useState("ar");
  const [statsLoading,setStatsLoading] = useState(true);
  const [visiteData,setVisiteData] = useState([]);
  const [memberData,setMemberData] = useState([]);
  const [memberCount,setMemberCount] = useState(0);
  const [totalHours,setTotalHours] = useState(0);
  const [visiteCount,setVisiteCount] = useState(0);
  const [averageHoursPerVisit,setAverageHoursPerVisit] = useState(0);
  const [mostActiveDay,setMostActiveDay] = useState("N/A");
  const [showAnnouncementModal,setShowAnnouncementModal] = useState(false);
  const [showCreditModal,setShowCreditModal] = useState(false);
  const [announcements,setAnnouncements] = useState([]);
  const [creditDue,setCreditDue] = useState(0);
  const [buvetteDue,setBuvetteDue] = useState(0);
  const [unpaidBuvetteOrders,setUnpaidBuvetteOrders] = useState([]);
  const [dark,setDark] = useState(() => localStorage.getItem("ws-theme")==="dark");
  const [deferredPrompt,setDeferredPrompt] = useState(null);
  const [showInstall,setShowInstall] = useState(false);
  const [installDismissed,setInstallDismissed] = useState(() => localStorage.getItem("ws-install-dismissed")==="true");
const [unreadMessages, setUnreadMessages] = useState(0);
  const toggleTheme = () => { setDark(d => { localStorage.setItem("ws-theme",!d?"dark":"light"); return !d; }); };

  useEffect(() => {
    const handler = e => { e.preventDefault(); setDeferredPrompt(e); if(!installDismissed) setShowInstall(true); };
    window.addEventListener("beforeinstallprompt",handler);
    return () => window.removeEventListener("beforeinstallprompt",handler);
  },[installDismissed]);

  useEffect(() => {
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
    if(isIos && !isStandalone && !installDismissed) setShowInstall(true);
  },[installDismissed]);

  const handleInstall = async () => {
    if(deferredPrompt){ deferredPrompt.prompt(); const{outcome}=await deferredPrompt.userChoice; if(outcome==="accepted") setShowInstall(false); setDeferredPrompt(null); }
  };
  const dismissInstall = () => { setShowInstall(false); setInstallDismissed(true); localStorage.setItem("ws-install-dismissed","true"); };

  useEffect(() => {
    const fetchAll = async () => {
      if(!user?.email || !user?.uid) return;
      try {
        const snap = await getDocs(query(collection(db,"contact"),where("email","==",user.email)));
        if(!snap.empty) {
          const d = snap.docs[0].data();

setPicUrl(d.Pic);
setFullName(d.fullname || d.name || "Utilisateur");
setLoyaltyPoints(d.Loyalty ?? null);
setLoyaltyStamps(d.LoyaltyStamps ?? null);

if (d.reservation_block === true) {
  setShowReservationBlockModal(true);
}
          if(d.signed){ setReglementSigned(true); } else { setTimeout(()=>setShowReglement(true),1200); }
          const credit = Number(d.Credit||0); setCreditDue(credit);
          const fullname = d.fullname||d.name||"";
          if(fullname) {
            try {
              const bSnap = await getDocs(query(collection(db,"buvette"),where("Paiement","==",false),where("Nom Client","==",fullname)));
              const orders = bSnap.docs.map(d=>({id:d.id,...d.data()}));
              setUnpaidBuvetteOrders(orders);
              const bt = orders.reduce((s,o)=>s+Number(o.Total||0),0);
              setBuvetteDue(Math.round(bt*1000)/1000);
              if(credit>0||orders.length>0) setTimeout(()=>setShowCreditModal(true),800);
            } catch(err){ console.error(err); }
          }
        }
      } catch { message.error("Impossible de charger le profil."); }
      try {
        const annSnap = await getDocs(query(collection(db,"administration"),where("__name__","==","Announcement_TV")));
        if(!annSnap.empty){ const msgs=annSnap.docs[0].data().message||[]; if(msgs.length>0){ setAnnouncements(msgs); setTimeout(()=>setShowAnnouncementModal(true),400); } }
      } catch {}
      try {
        const uid = user.uid;
        const [vSnap,mSnap] = await Promise.all([getDocs(query(collection(db,"visiteur"),where("FirebaseId","==",uid))),getDocs(query(collection(db,"members"),where("FirebaseId","==",uid)))]);
        const dh={}; let mh=0,md="";
        vSnap.forEach(d=>{ const v=d.data(); if(v.startTime&&v.hours){ const k=dayjs(v.startTime.toDate()).format("YYYY-MM-DD"); dh[k]=(dh[k]||0)+Number(v.hours); if(dh[k]>mh){mh=dh[k];md=dayjs(k).format("DD/MM/YYYY");} } });
        const fmt=Object.entries(dh).map(([date,hours])=>({date:dayjs(date).format("DD/MM"),fullDate:date,hours:Math.round(hours*10)/10})).sort((a,b)=>new Date(a.fullDate)-new Date(b.fullDate));
        setVisiteData(fmt);
        const tot=Object.values(dh).reduce((s,h)=>s+h,0);
        setTotalHours(Math.round(tot*10)/10); setVisiteCount(vSnap.size); setAverageHoursPerVisit(vSnap.size>0?Math.round((tot/vSnap.size)*10)/10:0); setMostActiveDay(md||"N/A");
        const ch={}; mSnap.forEach(d=>{ const h=d.data().Hours; if(h) ch[h]=(ch[h]||0)+1; });
        setMemberData(Object.entries(ch).map(([h,c])=>({hours:`${h}h`,hoursNum:parseInt(h),count:c})).sort((a,b)=>a.hoursNum-b.hoursNum));
        setMemberCount(mSnap.size);
      } catch(err){ console.error(err); }
      setStatsLoading(false);
            try {
        const uid = user.uid;
        const [announcementsSnap, directSnap] = await Promise.all([
          getDocs(query(collection(db, "messages"), where("to", "==", "all"))),
          getDocs(query(collection(db, "messages"), where("to", "==", uid), where("read", "==", false))),
        ]);
        const unreadAnnouncements = announcementsSnap.docs.filter(d => !(d.data().readBy || []).includes(uid)).length;
        setUnreadMessages(unreadAnnouncements + directSnap.size);
      } catch {}

    
    };
    
    fetchAll();
  },[user]);

  useEffect(()=>{ fetch("https://api.allorigins.win/raw?url=https://zenquotes.io/api/random").then(r=>r.json()).then(data=>{ if(Array.isArray(data)){ setQuote(data[0].q); setAuthor(data[0].a); } }).catch(()=>{}); },[]);
  useEffect(()=>{ if(!user) navigate("/login"); },[user,navigate]);
  if(!user) return null;

  const t = dark ? theme.dark : theme.light;
  const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const activityStatus = visiteCount>10?"Très actif":visiteCount>5?"Actif":"Modéré";
  const showAchievements = visiteCount>5||totalHours>20;
  const allChecked = RULES.every(r=>checkedRules[r.id]);

  const handleSignReglement = async () => {
    setSigningLoading(true);
    try {
      const snap = await getDocs(query(collection(db,"contact"),where("FirebaseId","==",user.uid)));
      if(!snap.empty){ await updateDoc(doc(db,"contact",snap.docs[0].id),{signed:true,signedAt:new Date()}); setReglementSigned(true); setShowReglement(false); }
    } catch(err){ console.error(err); }
    setSigningLoading(false);
  };

  const CustomTooltip = ({active,payload,label}) => {
    if(!active||!payload?.length) return null;
    return <div style={{background:t.cardBg,border:`1px solid ${t.border}`,borderRadius:10,padding:"10px 14px"}}><p style={{margin:0,fontSize:12,fontWeight:500,color:t.text1,marginBottom:4}}>{label}</p>{payload.map((e,i)=><p key={i} style={{margin:0,fontSize:12,color:e.color}}>{e.name}: <strong>{e.value}</strong></p>)}</div>;
  };

  return (
    <div style={{background:t.bg,minHeight:"100vh"}}>
      <div style={ST.page}>

        {showInstall && (
          <div style={{...ST.installBanner,background:t.blue}}>
            <div style={ST.installLeft}>
              <span style={{fontSize:22,flexShrink:0}}>📲</span>
              <div style={{minWidth:0}}>
                <div style={ST.installTitle}>Ajouter à l'écran d'accueil</div>
                <div style={ST.installSub}>{isIos?<>Appuyez sur <strong>⎋ Partager</strong> puis "Sur l'écran d'accueil"</>:"Accédez rapidement à WeStudy depuis votre téléphone"}</div>
              </div>
            </div>
            <div style={ST.installActions}>
              {!isIos && <button onClick={handleInstall} style={ST.installBtn}>Installer</button>}
              <button onClick={dismissInstall} style={ST.installClose}>✕</button>
            </div>
          </div>
        )}
<div style={ST.topbar}>
  <img src="/logo.PNG" alt="WeStudy" style={ST.logo} />
  <div style={ST.topbarRight}>
    {/* Messages icon with badge */}
    <button onClick={() => navigate("/messages")}
      style={{ position: "relative", background: t.bg3, border: `1px solid ${t.border}`, borderRadius: 10, width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: 18 }}>
      ✉️
      {unreadMessages > 0 && (
        <span style={{ position: "absolute", top: -5, right: -5, background: "#dc2626", color: "#fff", fontSize: 9, fontWeight: 800, borderRadius: 20, minWidth: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 4px", border: `2px solid ${t.bg}` }}>
          {unreadMessages > 9 ? "9+" : unreadMessages}
        </span>
      )}
    </button>

    <button onClick={toggleTheme} style={{...ST.toggleTrack, background:t.bg3, border:`1px solid ${t.border}`}}>
      <div style={{...ST.toggleKnob, background:t.blue, transform:dark?"translateX(16px)":"translateX(0)"}} />
    </button>
    <button onClick={logout} style={{...ST.logoutBtn, background:t.bg3, border:`1px solid ${t.border}`, color:t.text2}}>Déconnexion</button>
  </div>
</div>
        

        <div style={ST.hero}>
          <Avatar size={56} src={picUrl||`https://ui-avatars.com/api/?name=${encodeURIComponent(fullName)}&background=${dark?"1e3a5f":"dbeafe"}&color=${dark?"85B7EB":"1d4ed8"}&size=100`} style={{border:`2px solid ${t.blue}`,flexShrink:0}} />
          <div>
            <div style={{fontSize:12,color:t.text2,marginBottom:2}}>Bonjour 👋</div>
            <div style={{fontSize:19,fontWeight:500,color:t.text1}}>{fullName}</div>
            <span style={{...ST.badge,background:t.blueBg,color:t.blueText}}>Membre actif</span>
          </div>
        </div>

        <div style={{...ST.quoteBlock,background:t.blueBg,borderLeftColor:t.blue}}>
          <Text style={{fontSize:12,color:t.text2,fontStyle:"italic",lineHeight:1.6}}>"{quote}"{author&&<span style={{color:t.text3}}> — {author}</span>}</Text>
        </div>

        <div style={{...ST.sectionTitle,color:t.text3}}>Mes statistiques</div>
        {statsLoading ? <div style={{textAlign:"center",padding:"20px 0 16px"}}><Spin /></div> : (
          <Statspeek t={t} dark={dark}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(2, minmax(0,1fr))",gap:10,padding:"0 18px",marginBottom:12}}>
              <StatCard icon="⏱️" value={`${totalHours}h`} label="Total d'heures" color={t.blue} bg={t.blueBg} progress={Math.min((totalHours/100)*100,100)} t={t} />
              <StatCard icon="📅" value={visiteCount} label="Visites" color={t.green} bg={t.greenBg} progress={Math.min((visiteCount/50)*100,100)} t={t} />
              <StatCard icon="👥" value={memberCount} label="Abonnements" color={t.amber} bg={t.amberBg} progress={Math.min((memberCount/10)*100,100)} t={t} />
              <StatCard icon="📈" value={`${averageHoursPerVisit}h`} label="Moy. / visite" color={t.purple} bg={t.purpleBg} progress={Math.min((averageHoursPerVisit/8)*100,100)} t={t} />
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(2, minmax(0,1fr))",gap:10,padding:"0 18px",marginBottom:12}}>
              <div style={{background:t.cardBg,border:`1px solid ${t.border}`,borderRadius:14,padding:14,display:"flex",alignItems:"center",gap:10}}>
                <div style={{width:36,height:36,borderRadius:10,background:t.amberBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>🏆</div>
                <div><div style={{fontSize:10,color:t.text2}}>Jour le plus actif</div><div style={{fontSize:12,fontWeight:500,color:t.text1,marginTop:2}}>{mostActiveDay}</div></div>
              </div>
              <div style={{background:t.cardBg,border:`1px solid ${t.border}`,borderRadius:14,padding:14,display:"flex",alignItems:"center",gap:10}}>
                <div style={{width:36,height:36,borderRadius:10,background:t.blueBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>⚡</div>
                <div><div style={{fontSize:10,color:t.text2}}>Statut</div><div style={{fontSize:12,fontWeight:500,color:t.green,marginTop:2}}>{activityStatus}</div></div>
              </div>
            </div>
            <div style={{padding:"0 18px",marginBottom:12}}>
              <div style={{background:t.cardBg,border:`1px solid ${t.border}`,borderRadius:14,padding:14}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                  <span style={{fontSize:12,fontWeight:500,color:t.text1}}>Heures par jour</span>
                  <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,background:t.blueBg,color:t.blueText}}>{visiteData.length} jours</span>
                </div>
                {visiteData.length===0 ? <Empty description={<span style={{color:t.text2,fontSize:11}}>Aucune donnée</span>} image={Empty.PRESENTED_IMAGE_SIMPLE} /> : (
                  <ResponsiveContainer width="100%" height={140}>
                    <AreaChart data={visiteData}>
                      <defs><linearGradient id="blueGrad" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor={t.blue} stopOpacity={0.2}/><stop offset="95%" stopColor={t.blue} stopOpacity={0}/></linearGradient></defs>
                      <CartesianGrid strokeDasharray="3 3" stroke={t.border}/>
                      <XAxis dataKey="date" stroke={t.text3} tick={{fontSize:9,fill:t.text3}}/>
                      <YAxis stroke={t.text3} tick={{fontSize:9,fill:t.text3}}/>
                      <Tooltip content={<CustomTooltip/>}/>
                      <Area type="monotone" dataKey="hours" stroke={t.blue} strokeWidth={2} fill="url(#blueGrad)" name="Heures"/>
                    </AreaChart>
                  </ResponsiveContainer>
                )}
              </div>
            </div>
            {memberData.length>0 && (
              <div style={{padding:"0 18px",marginBottom:12}}>
                <div style={{background:t.cardBg,border:`1px solid ${t.border}`,borderRadius:14,padding:14}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                    <span style={{fontSize:12,fontWeight:500,color:t.text1}}>Abonnements par formule</span>
                    <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,background:t.greenBg,color:t.greenText}}>{memberCount} total</span>
                  </div>
                  <ResponsiveContainer width="100%" height={120}>
                    <BarChart data={memberData}>
                      <CartesianGrid strokeDasharray="3 3" stroke={t.border}/>
                      <XAxis dataKey="hours" stroke={t.text3} tick={{fontSize:9,fill:t.text3}}/>
                      <YAxis stroke={t.text3} tick={{fontSize:9,fill:t.text3}} allowDecimals={false}/>
                      <Tooltip content={<CustomTooltip/>}/>
                      <Bar dataKey="count" name="Abonnements" radius={[5,5,0,0]} barSize={30}>
                        {memberData.map((_,i)=><Cell key={i} fill={BAR_COLORS[i%BAR_COLORS.length]}/>)}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            )}
            {showAchievements && (
              <div style={{padding:"0 18px",marginBottom:12}}>
                <div style={{background:t.greenBg,border:`1px solid ${t.border}`,borderRadius:14,padding:"14px 16px",textAlign:"center"}}>
                  <div style={{fontSize:22,marginBottom:4}}>🎉</div>
                  <div style={{fontSize:13,fontWeight:600,color:t.greenText}}>Félicitations !</div>
                  <div style={{fontSize:11,color:t.text2,marginTop:3}}>Vous êtes un membre actif de notre communauté</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:6,justifyContent:"center",marginTop:8}}>
                    {totalHours>=50&&<span style={{fontSize:10,padding:"3px 8px",borderRadius:20,background:t.amberBg,color:t.amberText}}>🏆 +50h</span>}
                    {visiteCount>=10&&<span style={{fontSize:10,padding:"3px 8px",borderRadius:20,background:t.blueBg,color:t.blueText}}>⭐ Régulier</span>}
                    {memberCount>=3&&<span style={{fontSize:10,padding:"3px 8px",borderRadius:20,background:t.purpleBg,color:t.purpleText}}>💎 Fidèle</span>}
                  </div>
                </div>
              </div>
            )}
          </Statspeek>
        )}

        <div style={{...ST.divider,background:t.border}}/>

        <div style={{...ST.sectionTitle,color:t.text3}}>Services</div>
        <ResponsiveGrid>
          {cards.filter(c=>["Booking","Minuteur","Printing","Buvette","Powerbank","Loyalty","Incident","Casier","Booth","Équipements","Bibliothèque", "WeBot"].includes(c.title)).map(card=><CardItem key={card.title} card={card} t={t}/>)}
        </ResponsiveGrid>
        
        <div style={{height:20}}/>
        <div style={{...ST.divider,background:t.border}}/>

        <div style={{...ST.sectionTitle,color:t.text3}}>Mon espace</div>
        <ResponsiveGrid>
          {cards.filter(c=>["Mon Compte","Payer en Ligne","Parrainage","Late Access"].includes(c.title)).map(card=><CardItem key={card.title} card={card} t={t}/>)}
        </ResponsiveGrid>
        <div style={{height:12}}/>
        <WideCard card={cards.find(c=>c.title==="Vote")} t={t}/>

        {/* Announcement Modal */}
        {showAnnouncementModal && (
          <div style={{position:"fixed",inset:0,zIndex:1000,background:"rgba(0,0,0,0.5)",backdropFilter:"blur(4px)",display:"flex",alignItems:"flex-end",justifyContent:"center",padding:"0 0 24px"}} onClick={()=>setShowAnnouncementModal(false)}>
            <div style={{width:"100%",maxWidth:440,borderRadius:"20px 20px 16px 16px",padding:"20px 18px",background:t.cardBg,border:`1px solid ${t.border}`,boxShadow:"0 -4px 32px rgba(0,0,0,0.15)",maxHeight:"80vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{width:36,height:36,borderRadius:10,background:t.blueBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>📢</div>
                  <div style={{fontSize:15,fontWeight:600,color:t.text1}}>Annonces WeStudy</div>
                </div>
                <button onClick={()=>setShowAnnouncementModal(false)} style={{background:"none",border:"none",fontSize:18,color:t.text3,cursor:"pointer"}}>✕</button>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {announcements.map((msg,i)=><div key={i} style={{background:t.blueBg,borderLeft:`3px solid ${t.blue}`,borderRadius:"0 10px 10px 0",padding:"12px 14px",fontSize:13,color:t.text1,lineHeight:1.6}}>{msg}</div>)}
              </div>
              <button onClick={()=>setShowAnnouncementModal(false)} style={{marginTop:16,width:"100%",padding:"10px",borderRadius:10,border:"none",background:t.blue,color:"#fff",fontSize:13,fontWeight:600,cursor:"pointer"}}>J'ai compris</button>
            </div>
          </div>
        )}

        {/* Credit Modal */}
        {showCreditModal && (
          <div style={{position:"fixed",inset:0,zIndex:1000,background:"rgba(0,0,0,0.5)",backdropFilter:"blur(4px)",display:"flex",alignItems:"flex-end",justifyContent:"center",padding:"0 0 24px"}} onClick={()=>setShowCreditModal(false)}>
            <div style={{width:"100%",maxWidth:440,borderRadius:"20px 20px 16px 16px",padding:"20px 18px",background:t.cardBg,border:`1px solid ${t.border}`,boxShadow:"0 -4px 32px rgba(0,0,0,0.15)",maxHeight:"80vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{width:36,height:36,borderRadius:10,background:t.redBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>💰</div>
                  <div style={{fontSize:15,fontWeight:600,color:t.text1}}>Montants dus</div>
                </div>
                <button onClick={()=>setShowCreditModal(false)} style={{background:"none",border:"none",fontSize:18,color:t.text3,cursor:"pointer"}}>✕</button>
              </div>
              {creditDue>0&&(
                <div style={{background:t.redBg,border:`1px solid ${t.redBorder}`,borderRadius:12,padding:"14px 16px",marginBottom:10}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div><div style={{fontSize:13,fontWeight:600,color:t.red}}>Crédit dû à WeStudy</div><div style={{fontSize:12,color:t.text2,marginTop:2}}>À régler à l'accueil ou en ligne</div></div>
                    <div style={{fontSize:20,fontWeight:700,color:t.red}}>{creditDue} dt</div>
                  </div>
                </div>
              )}
              {unpaidBuvetteOrders.length>0&&(
                <div style={{background:t.amberBg,border:`1px solid ${t.border}`,borderRadius:12,padding:"14px 16px",marginBottom:10}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                    <div style={{fontSize:13,fontWeight:600,color:t.amber}}>Buvette non payée</div>
                    <div style={{fontSize:18,fontWeight:700,color:t.amber}}>{buvetteDue} dt</div>
                  </div>
                  {unpaidBuvetteOrders.map((order,i)=>(
                    <div key={i} style={{display:"flex",justifyContent:"space-between",fontSize:12,color:t.text2,padding:"6px 0",borderTop:`1px solid ${t.border}`}}>
                      <span>{order.Produit||"Commande"}</span>
                      <span style={{fontWeight:500,color:t.text1}}>{Number(order.Total).toFixed(3)} dt</span>
                    </div>
                  ))}
                </div>
              )}
              <div style={{fontSize:12,color:t.text2,textAlign:"center",marginBottom:12}}>Veuillez régler ces montants à l'accueil ou via <strong>Payer en ligne</strong>.</div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>setShowCreditModal(false)} style={{flex:1,padding:"10px",borderRadius:10,border:`1px solid ${t.border}`,background:t.bg3,color:t.text2,fontSize:13,cursor:"pointer"}}>Plus tard</button>
                <button onClick={()=>{setShowCreditModal(false);navigate("/payment");}} style={{flex:1,padding:"10px",borderRadius:10,border:"none",background:t.blue,color:"#fff",fontSize:13,fontWeight:600,cursor:"pointer"}}>💳 Payer maintenant</button>
              </div>
            </div>
          </div>
        )}

        {/* Règlement Modal */}
        {showReglement && !reglementSigned && (
          <div style={{position:"fixed",inset:0,zIndex:1100,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(4px)",display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
            <div style={{width:"100%",maxWidth:480,borderRadius:"20px 20px 0 0",background:t.cardBg,border:`1px solid ${t.border}`,boxShadow:"0 -4px 32px rgba(0,0,0,0.2)",maxHeight:"90vh",display:"flex",flexDirection:"column"}}>
              <div style={{padding:"20px 20px 0",flexShrink:0}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{width:36,height:36,borderRadius:10,background:t.redBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>📋</div>
                    <div>
                      <div style={{fontSize:15,fontWeight:700,color:t.text1}}>Règlement intérieur</div>
                      <div style={{fontSize:11,color:t.text2}}>النظام الداخلي — WeStudy</div>
                    </div>
                  </div>
                  <div style={{display:"flex",background:t.bg3,borderRadius:8,padding:2,gap:2}}>
                    {["fr","ar"].map(l=>(
                      <button key={l} onClick={()=>setReglementLang(l)} style={{padding:"4px 10px",borderRadius:6,border:"none",background:reglementLang===l?t.cardBg:"transparent",color:reglementLang===l?t.text1:t.text3,fontSize:12,fontWeight:reglementLang===l?600:400,cursor:"pointer"}}>
                        {l==="fr"?"FR":"AR"}
                      </button>
                    ))}
                  </div>
                </div>
                <div style={{fontSize:12,color:t.text2,marginTop:8,marginBottom:8,lineHeight:1.5}}>
                  {reglementLang==="fr"?"Veuillez lire et accepter chaque règle pour continuer.":"يرجى قراءة وقبول كل قاعدة للمتابعة."}
                </div>
                <div style={{fontSize:11,color:t.text3,marginBottom:12}}>
                  {Object.values(checkedRules).filter(Boolean).length} / {RULES.length} {reglementLang==="fr"?"règles acceptées":"قواعد مقبولة"}
                </div>
              </div>
              <div style={{overflowY:"auto",padding:"0 20px",flex:1}}>
                {RULES.map(rule=>(
                  <div key={rule.id} onClick={()=>setCheckedRules(prev=>({...prev,[rule.id]:!prev[rule.id]}))}
                    style={{display:"flex",alignItems:"flex-start",gap:12,padding:"12px 14px",marginBottom:8,borderRadius:12,cursor:"pointer",border:`1.5px solid ${checkedRules[rule.id]?t.green:t.border}`,background:checkedRules[rule.id]?t.greenBg:t.bg3,transition:"all 0.15s"}}>
                    <div style={{width:22,height:22,borderRadius:6,flexShrink:0,marginTop:1,border:`2px solid ${checkedRules[rule.id]?t.green:t.border}`,background:checkedRules[rule.id]?t.green:"transparent",display:"flex",alignItems:"center",justifyContent:"center",transition:"all 0.15s"}}>
                      {checkedRules[rule.id]&&<span style={{color:"#fff",fontSize:13,fontWeight:700}}>✓</span>}
                    </div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:11,fontWeight:700,color:t.text3,marginBottom:3}}>{reglementLang==="fr"?`Article ${rule.id}`:`المادة ${rule.id}`}</div>
                      <div style={{fontSize:13,color:checkedRules[rule.id]?t.green:t.text1,lineHeight:1.55,fontWeight:checkedRules[rule.id]?500:400,direction:reglementLang==="ar"?"rtl":"ltr"}}>
                        {reglementLang==="fr"?rule.fr:rule.ar}
                      </div>
                    </div>
                  </div>
                ))}
                <div style={{height:16}}/>
              </div>
              <div style={{padding:"16px 20px 32px",flexShrink:0,borderTop:`1px solid ${t.border}`}}>
                {!allChecked&&(
                  <div style={{fontSize:11,color:t.text3,textAlign:"center",marginBottom:10}}>
                    {reglementLang==="fr"?`Encore ${RULES.length-Object.values(checkedRules).filter(Boolean).length} règle(s) à accepter`:`تبقى ${RULES.length-Object.values(checkedRules).filter(Boolean).length} قاعدة/قواعد للقبول`}
                  </div>
                )}
                <button onClick={allChecked?handleSignReglement:undefined} disabled={!allChecked||signingLoading}
                  style={{width:"100%",padding:"14px",borderRadius:12,border:"none",background:allChecked?t.green:t.bg3,color:allChecked?"#fff":t.text3,fontSize:14,fontWeight:700,cursor:allChecked?"pointer":"not-allowed",transition:"all 0.2s",opacity:signingLoading?0.7:1}}>
                  {signingLoading?"Enregistrement...":allChecked?(reglementLang==="fr"?"✅ J'accepte le règlement":"✅ أوافق على النظام الداخلي"):(reglementLang==="fr"?"Acceptez toutes les règles pour continuer":"اقبل جميع القواعد للمتابعة")}
                </button>
              </div>
            </div>
          </div>
        )}
{/* Reservation Block Modal */}
{showReservationBlockModal && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 2000,
      background: "rgba(0,0,0,0.72)",
      backdropFilter: "blur(6px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: 420,
        background: t.cardBg,
        border: `1px solid ${t.border}`,
        borderRadius: 22,
        padding: "28px 22px",
        textAlign: "center",
        boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 18,
          background: t.redBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 30,
          margin: "0 auto 16px",
        }}
      >
        ⛔
      </div>

      <div
        style={{
          fontSize: 20,
          fontWeight: 800,
          color: t.text1,
          marginBottom: 8,
        }}
      >
        Réservation bloquée
      </div>

      <div
        style={{
          fontSize: 15,
          color: t.text2,
          lineHeight: 1.6,
          marginBottom: 22,
        }}
      >
        SVP contacter l'administration.
      </div>

      <button
        onClick={logout}
        style={{
          width: "100%",
          padding: "13px 16px",
          borderRadius: 12,
          border: "none",
          background: t.red,
          color: "#fff",
          fontSize: 14,
          fontWeight: 700,
          cursor: "pointer",
        }}
      >
        Déconnexion
      </button>
    </div>
  </div>
)}
        <WestudyCat t={t}/>
      </div>
    </div>
  );
}

function StatCard({icon,value,label,color,bg,progress,t}) {
  return (
    <div style={{background:t.cardBg,border:`1px solid ${t.border}`,borderRadius:14,padding:14}}>
      <div style={{width:30,height:30,borderRadius:8,background:bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,marginBottom:8}}>{icon}</div>
      <div style={{fontSize:20,fontWeight:700,color,lineHeight:1}}>{value}</div>
      <div style={{fontSize:11,color:t.text2,marginTop:3}}>{label}</div>
      <div style={{height:3,borderRadius:3,background:t.bg3,marginTop:8,overflow:"hidden"}}>
        <div style={{height:"100%",borderRadius:3,background:color,width:`${progress}%`}}/>
      </div>
    </div>
  );
}

function ResponsiveGrid({children}) {
  const [cols,setCols] = useState(2);
  useEffect(()=>{
    const update=()=>{ const w=window.innerWidth; if(w>=1024) setCols(4); else if(w>=640) setCols(3); else setCols(2); };
    update(); window.addEventListener("resize",update); return ()=>window.removeEventListener("resize",update);
  },[]);
  return <div style={{display:"grid",gridTemplateColumns:`repeat(${cols}, minmax(0, 1fr))`,gap:10,padding:"0 18px"}}>{children}</div>;
}

function CardItem({card,t}) {
  const [hovered,setHovered] = useState(false);
  const cs = card.comingSoon;
  return (
    <a href={cs?"#":card.link} onClick={cs?e=>e.preventDefault():undefined}
      style={{borderRadius:14,padding:"16px 14px",display:"flex",flexDirection:"column",gap:10,cursor:cs?"default":"pointer",transition:"border-color 0.15s, background 0.15s",background:cs?t.bg3:hovered?t.bg3:t.cardBg,border:`1px solid ${hovered&&!cs?t.blue:t.border}`,textDecoration:"none",opacity:cs?0.75:1,position:"relative",overflow:"hidden"}}
      onMouseEnter={()=>!cs&&setHovered(true)} onMouseLeave={()=>setHovered(false)}>
      {cs&&<div style={{position:"absolute",top:8,right:8,fontSize:10,fontWeight:600,padding:"2px 7px",borderRadius:20,background:t.amberBg,color:t.amberText}}>Bientôt</div>}
      <div style={{width:38,height:38,borderRadius:10,background:t.bg3,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>{card.emoji}</div>
      <div>
        <div style={{fontSize:13,fontWeight:500,color:t.text1,lineHeight:1.3}}>{card.title}</div>
        <div style={{fontSize:11,color:t.text2,lineHeight:1.5,marginTop:2}}>{card.description}</div>
      </div>
      {!cs&&<div style={{fontSize:12,color:t.text3,textAlign:"right"}}>→</div>}
    </a>
  );
}

function WideCard({card,t}) {
  const [hovered,setHovered] = useState(false);
  if(!card) return null;
  const cs = card.comingSoon;
  return (
    <a href={cs?"#":card.link} onClick={cs?e=>e.preventDefault():undefined}
      style={{display:"flex",alignItems:"center",gap:14,borderRadius:14,padding:"16px 18px",margin:"0 18px",cursor:cs?"default":"pointer",transition:"border-color 0.15s, background 0.15s",background:cs?t.bg3:hovered?t.bg3:t.cardBg,border:`1px solid ${hovered&&!cs?t.blue:t.border}`,textDecoration:"none",opacity:cs?0.75:1,position:"relative",overflow:"hidden"}}
      onMouseEnter={()=>!cs&&setHovered(true)} onMouseLeave={()=>setHovered(false)}>
      <div style={{width:44,height:44,fontSize:22,borderRadius:12,background:t.bg3,flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center"}}>{card.emoji}</div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:14,fontWeight:500,color:t.text1,display:"flex",alignItems:"center",gap:8}}>
          {card.title}
          {cs&&<span style={{fontSize:10,fontWeight:600,padding:"2px 7px",borderRadius:20,background:t.amberBg,color:t.amberText}}>Bientôt</span>}
        </div>
        <div style={{fontSize:12,color:t.text2,marginTop:2}}>{card.description}</div>
      </div>
      {!cs&&<span style={{fontSize:16,color:t.text3}}>→</span>}
    </a>
  );
}

function Statspeek({children,t,dark}) {
  const [expanded,setExpanded] = useState(false);
  return (
    <div style={{position:"relative",marginBottom:4}}>
      <div style={{maxHeight:expanded?"none":160,overflow:"hidden",transition:"max-height 0.4s ease"}}>{children}</div>
      {!expanded&&<div style={{position:"absolute",bottom:0,left:0,right:0,height:80,background:`linear-gradient(to bottom, transparent, ${dark?"#0f172a":"#f8fafc"})`,pointerEvents:"none"}}/>}
      <div style={{display:"flex",justifyContent:"center",marginTop:expanded?8:4}}>
        <button onClick={()=>setExpanded(e=>!e)} style={{display:"flex",alignItems:"center",gap:6,background:t.cardBg,border:`1px solid ${t.border}`,borderRadius:20,padding:"6px 16px",cursor:"pointer",fontSize:12,fontWeight:500,color:t.blue,boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
          <span>{expanded?"Réduire":"Voir mes statistiques"}</span>
          <span style={{display:"inline-block",transform:expanded?"rotate(180deg)":"rotate(0deg)",transition:"transform 0.3s",fontSize:14}}>↓</span>
        </button>
      </div>
    </div>
  );
}

function WestudyCat({ t }) {
  const [pos, setPos] = useState({ x: window.innerWidth - 110 });
  const [dir, setDir] = useState(-1);
  const [catState, setCatState] = useState("walk");
  const [chatOpen, setChatOpen] = useState(false);
  const [flipped, setFlipped] = useState(false);
  const [bobOffset, setBobOffset] = useState(0);
  const [activeChip, setActiveChip] = useState(null);
  const [pricing, setPricing] = useState(null);
  const [wifi, setWifi] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  const dirRef = useRef(dir);
  const catStateRef = useRef(catState);
  const animRef = useRef(null);
  const idleTimerRef = useRef(null);
  const bobRef = useRef(null);
  dirRef.current = dir;
  catStateRef.current = catState;

  // Fetch Firestore data when chat opens
  useEffect(() => {
    if (!chatOpen || dataLoaded) return;
    const fetchData = async () => {
      try {
        const [daily, monthly, weekly, wifiSnap] = await Promise.all([
          getDoc(doc(db, "Pricing", "Daily")),
          getDoc(doc(db, "Pricing", "Monthly")),
          getDoc(doc(db, "Pricing", "Weekly")),
          getDoc(doc(db, "administration", "WIFI")),
        ]);
        setPricing({
          daily: daily.data(),
          monthly: monthly.data(),
          weekly: weekly.data(),
        });
        setWifi(wifiSnap.data());
        setDataLoaded(true);
      } catch (err) { console.error(err); }
    };
    fetchData();
  }, [chatOpen, dataLoaded]);

  // Bob animation
  useEffect(() => {
    let tick = 0;
    bobRef.current = setInterval(() => { tick += 0.12; setBobOffset(Math.sin(tick) * 3); }, 50);
    return () => clearInterval(bobRef.current);
  }, []);

  // Walk loop
  useEffect(() => {
    const SPEED = 1.2, MARGIN = 20, CAT_W = 160;
    const scheduleIdle = () => {
      clearTimeout(idleTimerRef.current);
      idleTimerRef.current = setTimeout(() => {
        if (catStateRef.current === "walk") {
          setCatState("sit");
          setTimeout(() => { if (catStateRef.current === "sit") setCatState("walk"); }, 3000 + Math.random() * 3000);
        }
        scheduleIdle();
      }, 4000 + Math.random() * 6000);
    };
    scheduleIdle();
    animRef.current = setInterval(() => {
      if (catStateRef.current !== "walk") return;
      setPos(prev => {
        const maxX = window.innerWidth - CAT_W - MARGIN;
        let nx = prev.x + SPEED * dirRef.current;
        if (nx <= MARGIN) { nx = MARGIN; dirRef.current = 1; setDir(1); setFlipped(false); }
        else if (nx >= maxX) { nx = maxX; dirRef.current = -1; setDir(-1); setFlipped(true); }
        return { x: nx };
      });
    }, 16);
    return () => { clearInterval(animRef.current); clearTimeout(idleTimerRef.current); };
  }, []);

  const handleClick = () => { setCatState("sit"); setChatOpen(true); setActiveChip(null); };
  const handleClose = () => { setChatOpen(false); setCatState("walk"); setActiveChip(null); };

  const chips = [
    { id: "horaires",   emoji: "🕐", label: "Horaires" },
    { id: "tarifs",     emoji: "💳", label: "Tarifs" },
    { id: "wifi",       emoji: "📶", label: "WiFi" },
    { id: "buvette",    emoji: "☕", label: "Buvette" },
    { id: "impression", emoji: "🖨️", label: "Impression" },
    { id: "powerbank",  emoji: "🔋", label: "Powerbank" },
    { id: "lateaccess", emoji: "🌙", label: "Late Access" },
    { id: "reglement",  emoji: "📋", label: "Règlement" },
    { id: "adresse",    emoji: "📍", label: "Adresse" },
  ];

  const getAnswer = (id) => {
    switch (id) {
      case "horaires":
        return (
          <div>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>🕐 Horaires d'ouverture</div>
            <div>📅 Tous les jours — <strong>9h00 à 00h00</strong></div>
            <div style={{ marginTop: 4 }}>🚪 Dernier accès autorisé à <strong>22h00</strong></div>
            <div style={{ marginTop: 4, fontSize: 11, color: "#94a3b8" }}>WeStudy est ouvert 7j/7 toute l'année.</div>
          </div>
        );

      case "tarifs":
        if (!pricing) return <div>Chargement des tarifs... ⏳</div>;
        const { daily, monthly, weekly } = pricing;
        return (
          <div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>💳 Tarifs WeStudy</div>
            <div style={{ marginBottom: 6, fontWeight: 500 }}>📅 À la journée :</div>
            {Object.entries(daily).sort((a,b) => parseFloat(a[0]) - parseFloat(b[0])).map(([k, v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 2 }}>
                <span>{k}</span><span style={{ fontWeight: 600 }}>{v} dt</span>
              </div>
            ))}
            <div style={{ marginTop: 8, marginBottom: 6, fontWeight: 500 }}>📆 Hebdomadaire :</div>
            {Object.entries(weekly).sort((a,b) => parseFloat(a[0]) - parseFloat(b[0])).map(([k, v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 2 }}>
                <span>{k}</span><span style={{ fontWeight: 600 }}>{v} dt</span>
              </div>
            ))}
            <div style={{ marginTop: 8, marginBottom: 6, fontWeight: 500 }}>🗓️ Mensuel :</div>
            {Object.entries(monthly).sort((a,b) => parseFloat(a[0]) - parseFloat(b[0])).map(([k, v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 2 }}>
                <span>{k}</span><span style={{ fontWeight: 600 }}>{v} dt</span>
              </div>
            ))}
          </div>
        );

      case "wifi":
        if (!wifi) return <div>Chargement... ⏳</div>;
        return (
          <div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>📶 Connexion WiFi</div>
            <div style={{ background: "#f1f5f9", borderRadius: 8, padding: "10px 12px", fontSize: 13 }}>
              <div style={{ marginBottom: 4 }}>🔵 Réseau : <strong>{wifi.Réseau}</strong></div>
              <div style={{ marginBottom: 4 }}>👤 Identifiant : <strong>{wifi.Username}</strong></div>
              <div>🔑 Mot de passe : <strong>{wifi.Password}</strong></div>
            </div>
            <div style={{ fontSize: 11, marginTop: 6, color: "#94a3b8" }}>Connecte-toi avec ton e-mail et ton numéro de téléphone.</div>
          </div>
        );

      case "buvette":
        return (
          <div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>☕ Commander à la Buvette</div>
            <div style={{ marginBottom: 6 }}>Tu as <strong>2 façons</strong> de commander :</div>
            <div style={{ marginBottom: 8 }}>
              <div style={{ fontWeight: 500, marginBottom: 3 }}>📱 Via l'app :</div>
              <div style={{ fontSize: 12, lineHeight: 1.6 }}>
                1. Ouvre <strong>Buvette</strong> dans le menu<br />
                2. Choisis tes produits et ajoute-les au panier<br />
                3. Confirme la commande<br />
                4. Règle à l'accueil ✅
              </div>
            </div>
            <div>
              <div style={{ fontWeight: 500, marginBottom: 3 }}>📷 Scanner le code-barres :</div>
              <div style={{ fontSize: 12, lineHeight: 1.6 }}>
                Scanne directement le code-barres de ton produit depuis la page Buvette pour l'ajouter instantanément au panier.
              </div>
            </div>
          </div>
        );

      case "impression":
        return (
          <div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>🖨️ Imprimer un document</div>
            <div style={{ fontSize: 12, lineHeight: 1.7 }}>
              1. Va dans <strong>Impression</strong> depuis le menu<br />
              2. Choisis <strong>Impression</strong> ou <strong>Scan</strong><br />
              3. Upload ton fichier PDF<br />
              4. Sélectionne : couleur, recto/verso, copies<br />
              5. Lance l'impression<br />
              6. Le montant est ajouté à ton compte buvette 💳
            </div>
            <div style={{ marginTop: 8, fontSize: 11, color: "#94a3b8" }}>
              📠 Pour scanner : saisis ton e-mail, place le document sur le scanner et reçois le PDF directement.
            </div>
          </div>
        );

      case "powerbank":
        return (
          <div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>🔋 Emprunter une Powerbank</div>
            <div style={{ fontSize: 12, lineHeight: 1.7 }}>
              1. Va dans <strong>Powerbank</strong> depuis le menu<br />
              2. Scanne le QR code de la powerbank<br />
              3. Elle est associée à ton compte<br />
              4. Ramène-la à l'accueil une fois chargée ✅
            </div>
            <div style={{ marginTop: 8, fontSize: 11, color: "#94a3b8" }}>
              ⚠️ Toute powerbank non retournée sera facturée.
            </div>
          </div>
        );

      case "lateaccess":
        return (
          <div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>🌙 Late Access — Étudier la nuit</div>
            <div style={{ fontSize: 12, lineHeight: 1.7 }}>
              1. Va dans <strong>Late Access</strong> depuis le menu<br />
              2. Vérifie ton éligibilité (30h minimum + statut étudiant)<br />
              3. Fournis ta CIN + carte étudiante<br />
              4. Valide ton identité par e-mail<br />
              5. Attends l'approbation de l'équipe ✅
            </div>
            <div style={{ marginTop: 8, fontSize: 11, color: "#94a3b8" }}>
              🔐 L'accès nocturne est accordé après vérification uniquement.
            </div>
          </div>
        );

      case "reglement":
        return (
          <div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>📋 Règlement intérieur</div>
            <div style={{ fontSize: 12, lineHeight: 1.7 }}>
              Les points essentiels :<br />
              🤫 Silence obligatoire à l'intérieur<br />
              🧹 Table propre après usage<br />
              🚫 Pas de gobelets en papier<br />
              🚬 Pas de mégots devant l'entrée<br />
              🚗 Stationnement réglementé respecté<br />
              🤝 Comportement respectueux sur Farhat Hached<br />
              📅 3 no-show = 15 jours de suspension de réservation
            </div>
            <div style={{ marginTop: 8, fontSize: 11, color: "#94a3b8" }}>
              Tout manquement grave = exclusion définitive sans remboursement.
            </div>
          </div>
        );

      case "adresse":
        return (
          <div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>📍 Adresse WeStudy</div>
            <div style={{ fontSize: 13, lineHeight: 1.7 }}>
              🏢 <strong>Avenue Farhat Hached, Ezzahra</strong><br />
              Ben Arous, Tunisie
            </div>
            <div style={{ marginTop: 8 }}>
              <a href="https://maps.google.com/?q=WeStudy+Ezzahra" target="_blank" rel="noreferrer"
                style={{ fontSize: 12, color: "#2563eb", textDecoration: "none", fontWeight: 500 }}>
                🗺️ Ouvrir dans Google Maps →
              </a>
            </div>
          </div>
        );

      default: return null;
    }
  };

  const isSitting = catState === "sit";

  return (
    <>
      <div onClick={handleClick} style={{ position: "fixed", left: pos.x, bottom: 10, zIndex: 500, cursor: "pointer", userSelect: "none", transform: `translateY(${bobOffset}px) scaleX(${flipped ? -1 : 1})`, filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.2))" }}>
        {isSitting && !chatOpen && (
          <div style={{ position: "absolute", bottom: "105%", left: "50%", transform: `translateX(-50%) scaleX(${flipped ? -1 : 1})`, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: "5px 10px", fontSize: 11, fontWeight: 600, color: "#64748b", whiteSpace: "nowrap", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", marginBottom: 4, animation: "bubblePop 0.3s ease" }}>
            Clique-moi ! 👋
          </div>
        )}
        <img src="/cat-mascot.png" alt="Douja" style={{ width: 160, height: 160, objectFit: "contain" }} draggable={false} />
      </div>

      {chatOpen && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, display: "flex", alignItems: "flex-end", justifyContent: "center", padding: "0 0 116px" }}
          onClick={e => { if (e.target === e.currentTarget) handleClose(); }}>
          <div style={{ background: t.cardBg, border: `1px solid ${t.border}`, borderRadius: 20, padding: "20px 18px 18px", width: "calc(100% - 36px)", maxWidth: 420, boxShadow: "0 -4px 32px rgba(0,0,0,0.12)", animation: "slideUp 0.3s ease", maxHeight: "70vh", display: "flex", flexDirection: "column" }}>

            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14, flexShrink: 0 }}>
              <img src="/cat-mascot.png" alt="" style={{ width: 44, height: 44, objectFit: "contain", borderRadius: 12, background: t.bg3, padding: 4, border: `1px solid ${t.border}` }} />
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: t.text1 }}>Douja</div>
                <div style={{ fontSize: 11, color: t.text2 }}>Mascotte WeStudy 🐱</div>
              </div>
              <button onClick={handleClose} style={{ marginLeft: "auto", background: t.bg3, border: "none", borderRadius: 8, width: 28, height: 28, cursor: "pointer", fontSize: 14, color: t.text2 }}>✕</button>
            </div>

            {/* Answer area */}
            <div style={{ overflowY: "auto", flex: 1, marginBottom: 12 }}>
              {!activeChip ? (
                <div style={{ background: t.bg3, border: `1px solid ${t.border}`, borderRadius: "4px 16px 16px 16px", padding: "12px 14px", fontSize: 13, color: t.text1, lineHeight: 1.6 }}>
                  Miaou ! 🐾 Je suis <strong>Douja</strong>, mascotte de WeStudy !<br /><br />
                  Sur quoi puis-je t'aider ?
                </div>
              ) : (
                <div style={{ background: t.bg3, border: `1px solid ${t.border}`, borderRadius: "4px 16px 16px 16px", padding: "14px 16px", fontSize: 13, color: t.text1, lineHeight: 1.6 }}>
                  {getAnswer(activeChip)}
                </div>
              )}
            </div>

            {/* Chips */}
            <div style={{ flexShrink: 0 }}>
              <div style={{ fontSize: 11, color: t.text3, marginBottom: 8 }}>Choisir un sujet :</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 7 }}>
                {chips.map(chip => (
                  <button key={chip.id} onClick={() => setActiveChip(activeChip === chip.id ? null : chip.id)}
                    style={{ fontSize: 11, padding: "6px 11px", borderRadius: 20, border: `1.5px solid ${activeChip === chip.id ? t.blue : t.border}`, background: activeChip === chip.id ? t.blueBg : t.bg3, color: activeChip === chip.id ? t.blueText : t.text2, cursor: "pointer", fontWeight: activeChip === chip.id ? 600 : 400, transition: "all 0.15s" }}>
                    {chip.emoji} {chip.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes bubblePop { from{opacity:0;transform:translateX(-50%) scale(0.8)} to{opacity:1;transform:translateX(-50%) scale(1)} }
        @keyframes slideUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
      `}</style>
    </>
  );
}
const theme = {
  light:{bg:"#f8fafc",bg3:"#f1f5f9",border:"#e2e8f0",text1:"#0f172a",text2:"#64748b",text3:"#94a3b8",blue:"#2563eb",blueBg:"#eff6ff",blueText:"#1d4ed8",green:"#16a34a",greenBg:"#f0fdf4",greenText:"#15803d",greenBorder:"#bbf7d0",amber:"#d97706",amberBg:"#fffbeb",amberText:"#b45309",purple:"#7c3aed",purpleBg:"#f5f3ff",purpleText:"#6d28d9",red:"#dc2626",redBg:"#fef2f2",redBorder:"#fecaca",cardBg:"#ffffff"},
  dark:{bg:"#0f172a",bg3:"#1a2740",border:"#273549",text1:"#f1f5f9",text2:"#94a3b8",text3:"#475569",blue:"#378ADD",blueBg:"#1e3a5f",blueText:"#85B7EB",green:"#4ade80",greenBg:"#052e16",greenText:"#86efac",greenBorder:"#166534",amber:"#fbbf24",amberBg:"#2a1e07",amberText:"#fcd34d",purple:"#a78bfa",purpleBg:"#1e1244",purpleText:"#c4b5fd",red:"#f87171",redBg:"#2d1515",redBorder:"#7f1d1d",cardBg:"#1e293b"},
};
const ST = {
  page:{maxWidth:1200,margin:"0 auto",paddingBottom:40},
  installBanner:{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 18px",gap:12},
  installLeft:{display:"flex",alignItems:"center",gap:12,flex:1,minWidth:0},
  installTitle:{fontSize:13,fontWeight:600,color:"#fff",lineHeight:1.3},
  installSub:{fontSize:11,color:"rgba(255,255,255,0.85)",marginTop:2,lineHeight:1.4},
  installActions:{display:"flex",alignItems:"center",gap:8,flexShrink:0},
  installBtn:{fontSize:12,fontWeight:600,padding:"6px 14px",borderRadius:8,border:"none",background:"#fff",color:"#2563eb",cursor:"pointer",whiteSpace:"nowrap"},
  installClose:{fontSize:14,background:"transparent",border:"none",color:"rgba(255,255,255,0.7)",cursor:"pointer",padding:"4px 6px",lineHeight:1},
  topbar:{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"16px 18px 0"},
  logo:{height:48,objectFit:"contain"},
  topbarRight:{display:"flex",alignItems:"center",gap:10},
  toggleTrack:{width:36,height:20,borderRadius:20,cursor:"pointer",position:"relative",flexShrink:0},
  toggleKnob:{width:14,height:14,borderRadius:"50%",position:"absolute",top:2,left:2,transition:"transform 0.2s"},
  logoutBtn:{fontSize:12,borderRadius:8,padding:"6px 12px",cursor:"pointer",fontWeight:400},
  hero:{padding:"20px 18px 20px",display:"flex",alignItems:"center",gap:14},
  badge:{display:"inline-block",marginTop:5,fontSize:11,padding:"2px 10px",borderRadius:20},
  quoteBlock:{margin:"0 18px 24px",borderLeft:"3px solid",borderRadius:"0 10px 10px 0",padding:"12px 14px"},
  sectionTitle:{fontSize:11,fontWeight:500,letterSpacing:"0.08em",textTransform:"uppercase",padding:"0 18px",marginBottom:12},
  divider:{height:1,margin:"0 18px 20px"},
};